// @flow

import type { DeviceType } from '@chatchamp/chatchamp-types'

export function createState (customerId: string, subscriberId: string, parentUrl: string, device: DeviceType): any {
  return {
    cartProducts: [],
    channel: {}, // :Shop
    currentTab: 'chat',
    customerId,
    device,
    isTypingEnabled: false,
    isWsReady: false,
    parentUrl,
    productAddingToCart: null,
    routineAddingToCart: false,
    subscriberId
  }
}
